var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "footer pcfooter-template1",
    style: {
      backgroundColor: _vm.formData.bgColor
    }
  }, [_c("div", {
    staticClass: "common_content"
  }, [_c("div", {
    staticClass: "footer_info"
  }, [_vm._l(_vm.formData.custominfo, function (item, i) {
    return [item.type === 0 ? [_c("div", {
      staticClass: "logo_info",
      style: {
        "--logoActColor": item.textActFontColor
      }
    }, [item.logoPath ? _c("YYImage", {
      style: {
        width: item.logoWidth + "px",
        marginBottom: "32px",
        height: "auto"
      },
      attrs: {
        lazy: false,
        src: _vm.imgHost + item.logoPath
      }
    }) : _vm._e(), _c("div", [_c("p", {
      staticClass: "contactinfo",
      style: {
        fontSize: item.textFontSize + "px",
        color: item.textFontColor
      }
    }, [_vm._v(" " + _vm._s(item.subContent[_vm.defaultLangId]) + " ")])]), item.shareIcon.length ? _c("div", {
      staticClass: "share",
      staticStyle: {
        position: "relative"
      }
    }, [_vm._l(item.shareIcon, function (item2, i2) {
      return [item2.status ? _c("a", {
        key: i2,
        style: {
          marginRight: (item.shareIconMarignRight || 0) + "px",
          marginBottom: (item.shareIconMarignBottom || 0) + "px"
        },
        attrs: {
          href: item.content,
          clsss: "share-icon",
          target: "_blank"
        }
      }, [_c("img", {
        style: {
          width: (item2.icon_size || 0) + "px",
          height: (item2.icon_size || 0) + "px",
          objectFit: "cover"
        },
        attrs: {
          src: _vm.imgHost + item2.icon_link
        }
      }), item2.type == 1 && item2.content ? _c("div", {
        staticClass: "qrcode"
      }, [_c("img", {
        staticStyle: {
          width: "121px"
        },
        attrs: {
          src: _vm.imgHost + item2.content
        }
      })]) : _vm._e()]) : _vm._e()];
    })], 2) : _vm._e()], 1)] : _vm._e(), item.type === 1 ? [_c("div", {
      key: item + i,
      staticClass: "info"
    }, [_c("h3", {
      style: {
        fontSize: item.titleFontSize + "px",
        color: item.titleColor,
        fontWeight: 700
      }
    }, [_vm._v(" " + _vm._s(item.title[_vm.defaultLangId]) + " "), _c("div", {
      staticClass: "menu-line",
      style: {
        borderBottomColor: item.titleSubColor
      }
    })]), _c("dd", _vm._l(item.content, function (item2, i2) {
      return _c("a", {
        key: i2,
        attrs: {
          target: "_blank"
        }
      }, [_c("div", {
        ref: "link-item" + i,
        refInFor: true,
        style: {
          fontSize: item.textFontSize + "px",
          color: item.textFontColor
        },
        on: {
          mouseenter: function mouseenter($event) {
            return _vm.handleHoverColorEnter(_vm._self, "link-item" + i, item.hoverTextFontColor, i2);
          },
          mouseleave: function mouseleave($event) {
            return _vm.handleHoverColorLeave(_vm._self, "link-item" + i, i2);
          }
        }
      }, [_vm._v(" " + _vm._s(item2.title[_vm.defaultLangId]) + " ")])]);
    }), 0)])] : _vm._e()];
  })], 2), _c("div", {
    staticClass: "footer-line",
    style: {
      height: "1px",
      backgroundColor: _vm.formData.coyprightLineColor
    }
  }), _c("div", {
    staticClass: "footer_bottom"
  }, [_c("div", {
    style: {
      color: _vm.formData.coyprightTextColor,
      fontSize: _vm.formData.coyprightFontSize + "px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.coypright) + " ")])])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };